import "./chain.scss";
import {buildColumnDefs} from "./ChainColumnDefs";

"use strict";
{
    var validMonths = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
    var chainTemplate = `<div tabindex="-1"
     class="tfPopover popover top optnchain"
     style="outline: none; max-width:calc(100vw - 30px); margin-top: 15px; min-width: 1000px; width: 70%; left: 15px;">
    <div class="arrow" style="left: 35%"></div>
    <div style="padding: 10px">
        <div style="position: relative">
            <div class="" style="height: 48px;">
                <div class="tabbable-line" style="height: 48px;">
                    <ul class="nav nav-tabs mr-5" style="display: inline-block; border-right: 3px dashed grey;">
                        <li ng-repeat="year in years"
                            ng-class="{active : currentSeries.year === year}"
                            style="display : inline"><a ng-click="onSelectYear(year)" style="padding: 10px">
                            <uib-tab-heading>{{('' +year.year)}}</uib-tab-heading>
                        </a></li>
                    </ul>
                    <ul class="nav nav-tabs ml-5" style="display: inline-block">
                        <li ng-repeat="series in currentSeries.year.series"
                            ng-class="{active : currentSeries === series}"
                            style="display : inline ">
                            <a ng-click="onSelectSeries(series)" style="padding: 10px;">
                                <uib-tab-heading>
                                <span ng-if="series.week">W{{series.week}}</span>
                                {{series.expiry | date:'MMM'}}
                                </uib-tab-heading>
                            </a>
                        </li>
                    </ul>
                    <div class="price">
                        <div class="ticker" style="margin-top: -11px;">
                            <div class="monthSeries">{{currentSeries.expiry | date:'dd MMM yy'}} <small>({{currentSeries.expiry | daysFromNow}}d)</small></div>
                            <div style="text-align: center; font-size: 30px;">{{chain.code}}</div>
                        </div>
                        <div class="moreInfo"><span class="currentPrice">{{currentPrice.price | strike : chain.code === 'XJO'}} </span>
                            <div class="currentTime">{{currentPrice.priceDate | date:'MMM d, y h:mm a'}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" style=" text-align: center">
                <div class="col-xs-5">
                    <h4 style="line-height: 5px;">
                        <strong>Calls</strong>
                    </h4>
                </div>
                <div class="col-xs-5 col-xs-offset-2">
                    <h4 style="line-height: 5px;">
                        <strong>Puts</strong>
                    </h4>
                </div>
            </div>
        </div>
    </div>
    <div ui-grid="gridOptions" external-scopes="$scope"></div>
    <div class="optionPickerFooter">
        <div class="pull-left">
            <button ng-if="cchain.code !== 'XJO'" class="btn btn-success" ng-click="selectUnderlying()">
                BUY UNDERLYING STOCK
            </button>
        </div>
        <div class="pull-right">
            <button ng-if="canTradeLepos && currentSeries.lepo"
                    class="btn btn-success"
                    ng-click="selectInstrument(currentSeries.lepo)">
                BUY LEPO
            </button>
        </div>
    </div>
</div>`;

    var chainTemplateLinker;

    var module = angular.module('tf.chain', [])

        .controller('optionsChainPopoverCtrl', ['$scope', function ($scope) {


            $scope.checkModel = {
                american: false,
                euro: true,
                call: true,
                put: false
            };
        }])

        .directive( 'chainPopoverHtmlPopup', [ function() {
            return {
                restrict: 'EA',
                replace: true,
                scope: { title: '@', content: '@', placement: '@', animation: '&', isOpen: '&' },
                templateUrl: 'chain/options.html'
            };
        }])

        .directive( 'chainPopoverHtml', [ '$compile', '$timeout', '$parse', '$window', '$uibTooltip', function ( $compile, $timeout, $parse, $window, $uibTooltip ) {
            return $uibTooltip( 'chainPopoverHtml', 'popover', 'click' );
        }])

        .directive('chain', ['$timeout', '$compile', '$document', '$uibPosition', 'chainService', 'optionPriceService', 'openInterestService', 'spreadService', 'gridUtil', 'uiGridConstants', 'userConfig', 'priceStrategyService', function ($timeout, $compile, $document, $uibPosition, chainService, optionPriceService, openInterestService, spreadService, gridUtil, uiGridConstants, userConfig, priceStrategyService) {

            return {
                restrict: 'A',
                require: '^ngModel',
                compile : compile,
                scope : {
                    ngModel: '=ngModel',
                    instrumentSelected : '&instrumentSelected',
                    underlyingSelected : '&underlyingSelected',
                    cookbookSelected : '&cookbookSelected'
                }
            };

            function findClosestStrike(series, strike) {
                if (!strike) {
                    return undefined;
                }

                var selectedStrike = null;

                for (var i = 0; i < series.ladder.length; i++) {
                    var priceRung = series.ladder[i];

                    if (priceRung.level >= strike) {
                        if (selectedStrike == null) {
                            selectedStrike = priceRung;
                        }
                    }
                }

                if (selectedStrike == null) {
                    selectedStrike = series.ladder[series.ladder.length - 1];
                }

                return selectedStrike.level;
            }

            function compile(tElem,attrs) {

                chainTemplateLinker = $compile(chainTemplate);

                return {
                    pre: link
                };
            }


            function link(scope, element, attrs, ngModel) {
                scope.$scope = scope;
                scope.openInterest = null;
                scope.options = null;
                scope.userConfig = userConfig;
                scope.canTradeLepos = userConfig.adviser != null;

                var hideTimer = null;

                function maybeScrollToSelectedOption() {
                    if (scope.pendingSelectedStrike) {
                        var matches = scope.gridApi.grid.rows.filter(function (row) {
                            return row.entity.level >= scope.pendingSelectedStrike;
                        });

                        if (matches && matches.length > 0) {
                            $timeout(function() {
                                scope.gridApi.grid.scrollTo(matches[0].entity, undefined);
                            }, 0);
                        }
                    }
                }

                scope.gridOptions = {
                    flatEntityAccess : true,
                    enableVerticalScrollbar : uiGridConstants.scrollbars.ALWAYS,
                    enableHorizontalScrollbar : uiGridConstants.scrollbars.NEVER,
                    enableSorting: false,
                    enableColumnMenus : false,
                    onRegisterApi: function(gridApi){
                        scope.gridApi = gridApi;
                        gridUtil.disableAnimations(gridApi.grid.element);
                        gridApi.core.on.rowsRendered(scope, maybeScrollToSelectedOption);
                    },

                    //rowTemplate : "<div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + '-' + col.uid + '-cell'\" class=\"ui-grid-cell\" ng-class=\"{ 'ui-grid-row-header-cell': col.isRowHeader }\" role=\"{{col.isRowHeader ? 'rowheader' : 'gridcell'}}\" ui-grid-cell></div>",
                    excessRows : 100,
                    minRowsToShow : 9,
                    columnDefs: buildColumnDefs(userConfig),
                    data :  []
                };

                scope.calculateWidth = function (cols) {
                    var width = 0;
                    for (var i = 6; i < cols.length; i++) {
                        width += cols[i].drawnWidth;
                    }

                    return width;
                };

                scope.selectCookbook = function() {
                    if (scope.cookbookSelected) {
                        scope.cookbookSelected({underlying : scope.chain.code});
                        hide();
                    }
                };

                scope.selectUnderlying = function() {
                    if (scope.underlyingSelected) {
                        var code = scope.chain.code.toUpperCase();
                        scope.underlyingSelected({underlying : scope.chain.code});
                        scope.ngModel = {
                            code: code,
                            security: {
                                code: code
                            }
                        };
                        hide();
                    }
                };

                // TODO this is the final assignment to the model
                scope.selectInstrument = function (instrument) {
                    scope.selectedInstrument = instrument;
                    scope.inputFilter.strike = undefined;
                    scope.inputFilter.expiry = undefined;

                    scope.ngModel = instrument;
                };

                scope.doubleSelectInstrument = function(instrument) {
                    if (scope.instrumentSelected) {
                        scope.instrumentSelected(instrument);
                        hide();
                    }
                };

                var popup = chainTemplateLinker(scope, angular.noop);
                popup[0].addEventListener('focus', focusAndSelectInput, true);

                $document.find('body').append(popup);

                function focusAndSelectInput() {
                    element.focus();
                }

                function show() {
                    if (!scope.chain) {
                        return;
                    }

                    if (hideTimer) {
                        $timeout.cancel(hideTimer);
                        hideTimer = null;
                    }

                    if (scope.visible) {
                        return;
                    }

                    scope.visible = true;
                    popup[0].style.display = 'block';
                    var position = attrs.popupLocation || 'bottom-left';

                    scope.visible = true;
                    popup[0].style.display = 'block';
                    var ttPosition = $uibPosition.positionElements(element, popup, position, true);

                    if (position.indexOf('bottom') > -1) {
                        popup[0].style.top = ttPosition.top + "px";
                        popup.removeClass("top").addClass("bottom");
                    } else {
                        popup[0].style.top = (ttPosition.top - element[0].clientHeight)  + "px";
                        popup.removeClass("bottom").addClass("top");
                    }

                    scope.gridApi.core.handleWindowResize();
                }

                function hide() {
                    if (hideTimer) {
                        $timeout.cancel(hideTimer);
                        hideTimer = null;
                    }

                    hideTimer = $timeout(function() {
                        popup[0].style.display = 'none';
                        scope.visible = false;
                    }, 0);
                }

                scope.show = show;
                scope.hide = hide;

                element.bind('keyup', possiblyClose);
                element.bind('focus', show);
                element.bind('blur', hide);

                scope.$on('$destroy', function() {
                    element.unbind('keyup', possiblyClose);
                    element.unbind('blur', hide);
                    element.unbind('focus', show);
                    popup[0].removeEventListener('focus', focusAndSelectInput);

                    popup.remove();
                });

                scope.showSeries = function(series) {
                    scope.currentSeries = series;
                    optionPriceService(scope.chain.code, series.expiry).then(function(prices) {
                        scope.currentPrice = prices;
                        scope.openInterest.then(function(oi) {

                                spreadService(scope.chain.code, series.expiry).then(function (spreads) {
                                    scope.gridOptions.data = series.ladder.map(function (rung) {
                                        var put = null;
                                        if (rung.put) {
                                            put = {
                                                option: rung.put,
                                                oi: oi.interest[rung.put.code] || 0,
                                                spread: spreads.spread[rung.put.code],
                                                price: prices.options[rung.put.code],
                                                itm: prices.price <= rung.level
                                            };
                                        }

                                        var call = null;
                                        if (rung.call) {
                                            call = {
                                                option: rung.call,
                                                oi: oi.interest[rung.call.code] || 0,
                                                spread: spreads.spread[rung.call.code],
                                                price: prices.options[rung.call.code],
                                                itm: prices.price >= rung.level
                                            };
                                        }
                                        return {
                                            special: false,
                                            level: rung.level,
                                            put: put,
                                            call: call
                                        };
                                    });

                                    scope.scrollToStrike(findClosestStrike(series, scope.inputFilter.strike) || prices.price);
                                });
                        });
                    });
                };

                scope.onSelectYear = function(year) {
                    var defaultSeries = year.defaultSeries || year.firstSeries;
                    if (defaultSeries != scope.currentSeries) {
                        scope.showSeries(defaultSeries);
                    }
                };

                scope.onSelectSeries = function(series) {
                    // TODO need to use the input filter price too if we have it
                    if (series != scope.currentSeries) {
                        scope.showSeries(series);
                    }
                };

                scope.scrollToStrike = function (selectedStrike) {
                    scope.pendingSelectedStrike = selectedStrike;
                };


                function possiblyClose(e) {
                    if (e.keyCode == 27) {
                        ngModel.$setViewValue('');
                        ngModel.$render();
                    }
                }

                ngModel.$formatters.push(function() {
                    var instrument = ngModel.$modelValue;
                    if (instrument) {
                        var display = instrument.security.code;
                        // If it wasn't a really fake and horrible instrument that is actually an underlying then this info wont be there
                        if (instrument.expiry != null) {
                            display += " " + validMonths[instrument.expiry.getMonth()] + " " + ("" +instrument.expiry.getFullYear()).substring(2, 4) + " " + instrument.strike + " " + instrument.type + " " + instrument.style;
                        }
                        return display;
                    }
                    scope.chain = null;
                    scope.priceStrategy = null;
                });

                ngModel.$parsers.push(function(value) {
                    var validCalls = ['C', 'CALL'];
                    var validPuts = ['P', 'PUT'];

                    var input = value;

                    var parts = input.split(' ');
                    var underlying = parts.shift().toUpperCase();


                    if (underlying.length < 3) {
                        scope.chain = null;
                        scope.priceStrategy = null;
                        scope.gridOptions.data = [];
                        hide();
                        return;
                    }

                    scope.inputFilter = {
                        code : null, // used for selecting a known code and for return
                        underlying : underlying,
                        expiry : null,
                        put : true,
                        call : true,
                        strike : null
                    };

                    if (underlying.length > 3 && underlying.length != 6) {
                        return;
                    }

                    if (underlying.length == 6) {

                        var underlyingCode = underlying.substring(0, 3).toUpperCase();
                        // Load up a chain if the user pasted in an instrument code
                        if (scope.chain == null || scope.chain.code !== underlyingCode) {
                            scope.options = chainService(underlyingCode);
                            scope.openInterest = openInterestService(underlyingCode);
                        }

                        scope.options.then(function (chain){
                            // TODO check why this may be null. If the underlying was invalid, we should be telling the user
                            if (!chain) {
                                return;
                            }

                            if (!scope.chain) {
                                scope.chain = chain;
                                scope.priceStrategy = priceStrategyService.forCode(scope.chain.code);
                                scope.gridOptions.data = [];
                                loadChain(scope.chain);
                            }

                            var option = scope.chain.codes[underlying.toUpperCase()];
                            // Possible for a user to type in an incorrect code
                            if (option) {
                                scope.inputFilter = {
                                    code: option.code,
                                    underlying: underlying.toUpperCase().substring(0, 3),
                                    expiry: option.expiry,
                                    put: option.put,
                                    call: option.call,
                                    strike: option.strike
                                };

                                scope.selectInstrument(option);

                                scope.showSeries(option.series);

                                show();
                            }
                        });
                        return undefined;
                    }

                    var peek;
                    while ((peek = parts.shift()) != null) {

                        //find things that look like a month/Year and split it out
                        // TODO check for long spelling of month?
                        if (peek.length > 3 && validMonths.indexOf(peek.substring(0, 3).toUpperCase()) != -1) {
                            var month = peek.substring(0, 3);
                            var possibleYear = peek.substring(3);
                            parts.shift();
                            parts.unshift(month, possibleYear);
                            continue;
                        }

                        if (validMonths.indexOf(peek.toUpperCase()) != -1) {
                            var today = new Date();
                            var thisYear = today.getFullYear();
                            var thisMonth = today.getMonth();
                            var month = validMonths.indexOf(peek.toUpperCase());


                            // looking for month
                            peek = parts.shift();
                            var possibleYear = +peek;
                            if (possibleYear < 2000) {
                                possibleYear += 2000;
                            }

                            // Check based on the month too (if we are past the month and the year is in the past or this year it can't be a year)
                            if (!isNaN(possibleYear) && Math.abs(possibleYear - thisYear) < 4) {
                                // looks like a year
                                scope.inputFilter.expiry = new Date(possibleYear, month, 1);
                            } else {
                                parts.unshift(peek);

                                // TODO need to check the actual expiry date against today, or just say this month is still ok
                                if (thisMonth <= month) {
                                    scope.inputFilter.expiry = new Date(thisYear, month, 1);
                                } else {
                                    scope.inputFilter.expiry = new Date(thisYear + 1, month, 1);
                                }
                            }
                            continue;
                        }

                        if (validPuts.indexOf(peek) != -1) {
                            scope.inputFilter.put = true;
                            scope.inputFilter.call = false;
                            continue
                        }

                        if (validCalls.indexOf(peek) != -1) {
                            scope.inputFilter.put = false;
                            scope.inputFilter.call = true;
                            continue;
                        }

                        // Last thing to try is the price
                        if (!isNaN(+peek)) {
                            scope.inputFilter.strike = +peek;
                        } else {
                            var possiblePutCall = peek.charAt(peek.length - 1).toUpperCase();
                            var possibleStrike = peek.substring(0, peek.length - 1);
                            if (possiblePutCall == "P" || possiblePutCall == "C") {
                                parts.unshift(possibleStrike, possiblePutCall);
                            }
                        }
                    }

                    if (scope.chain == null || scope.chain.code != underlying) {
                        scope.options = chainService(underlying);
                        scope.openInterest = openInterestService(underlying);

                        scope.options.then(function (chain){
                            scope.chain = chain;
                            scope.priceStrategy = priceStrategyService.forCode(scope.chain.code);
                            scope.currentSeries = null;
                            scope.currentPrice = null;

                            if (scope.chain.codes) {
                                scope.gridOptions.data = [];
                                loadChain(scope.chain);
                                var series = findClosestSeries(scope.inputFilter.expiry || new Date());

                                if (series) {
                                    if (!scope.inputFilter.expiry) {
                                        // TODO should be on the chain as a default year which has a default series

                                        if (series.year.defaultSeries != null) {
                                            series = series.year.defaultSeries;
                                        } else {
                                            series = series.year.nextYear.defaultSeries;
                                        }
                                    }
                                    scope.showSeries(series);
                                    show();
                                }
                            } else {
                                hide();
                            }
                        });
                    } else {
                        var series = findClosestSeries(scope.inputFilter.expiry || new Date());

                        if (!scope.inputFilter.expiry) {
                            // TODO should be on the chain as a default year which has a default series
                            series = series.year.defaultSeries || series.year.firstSeries;
                        }
                        scope.showSeries(series);
                        show();
                    }

                    // TODO need the default year (may need to roll forward)
                    // Keep rolling forward while we only have a weekly first/default series (what is the difference)
                    function loadChain(chain) {
                        scope.years = [];

                        var tmpYear = {
                            year : 0,
                            series : []
                        };
                        for (var i = 0; i < chain.series.length; i++) {
                            var series = chain.series[i];

                            if (series.expiry.getFullYear() != tmpYear.year) {
                                var lastYear = tmpYear;
                                tmpYear = {
                                    year: series.expiry.getFullYear(),
                                    series: [],
                                    firstSeries : series,
                                    defaultSeries : null,
                                    firstQuarterSeries : null

                                };
                                lastYear.nextYear = tmpYear;
                                scope.years.push(tmpYear);
                            }

                            if (!series.week) {
                                if (tmpYear.defaultSeries == null) {
                                    tmpYear.defaultSeries = series;
                                }

                                // XJO usually uses a quarterly expiry
                                if (underlying == 'XJO' && tmpYear.firstQuarterSeries == null) {
                                    if (((series.expiry.getMonth() + 1) % 3) == 0) {
                                        tmpYear.firstQuarterSeries = series;
                                    }
                                }
                            }

                            // TODO try not to mangle the data that was passed in
                            series.year = tmpYear;
                            tmpYear.series.push(series);
                        }

                        // TODO if today is expiry day move the default series to the next available one (will not be a weekly and may be next year)
                    }


                    function findClosestSeries(expiry) {
                        var selectedYear = null;

                        for (var i = 0; i < scope.years.length; i++) {
                            var year = scope.years[i];

                            if (selectedYear == null && year.year >= expiry.getFullYear()) {
                                selectedYear = year;
                                break;
                            }
                        }

                        if (selectedYear == null) {
                            if (!scope.years.length) {
                                return;
                            }
                            selectedYear = scope.years[scope.years.length - 1];
                        }

                        var selectedSeries = null;


                        for (var i = 0; i < selectedYear.series.length; i++) {
                            var series = selectedYear.series[i];

                            if (selectedSeries == null && series.expiry >= expiry) {
                                selectedSeries = series;
                            }

                        }

                        if (selectedSeries == null) {
                            selectedSeries = scope.chain.series[scope.chain.series.length - 1];
                        }

                        return selectedSeries;
                    }

                });
            }

        }]);
}
